var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { $ } from 'hanako-ts/dist-legacy/Framework';
import { Component } from 'hanako-ts/dist-legacy/Component';
export class CoverResizer extends Component {
    constructor() {
        super('CoverResizer', false);
    }
    init() {
        const _super = Object.create(null, {
            init: { get: () => super.init }
        });
        return __awaiter(this, void 0, void 0, function* () {
            yield _super.init.call(this);
            if ($('.book-informations, .people-informations').length > 0) {
                // Cover resize
                $(window).on('scroll', () => {
                    CoverResizer.resizeCover();
                });
                // Resize stuff
                $(window).on('resize', () => {
                    CoverResizer.resize();
                });
                setTimeout(() => {
                    CoverResizer.resize();
                }, 1000);
                CoverResizer.resize();
            }
            this.success();
        });
    }
    static resize() {
        $('.book-informations .book-thumbnail, .people-informations .people-thumbnail').css('width', 'auto');
        const bookInformationBounding = $('.book-informations, .people-informations').get(0).getBoundingClientRect();
        this.enableCoverResize = bookInformationBounding.bottom > $(window).height();
        this.covers.each((cover, index) => {
            this.coversMaxHeight[index] = $(window).height() - bookInformationBounding.top - parseInt(cover.css('margin-bottom')) - $('.book-details, .people-details').height() - 36;
        });
        const mainContent = $('.book-content, .people-content');
        mainContent.css('--book-header-height', ($('.book-title .position-fixed, .people-title .position-fixed').height() - parseFloat($('.book-title .position-fixed, .people-title .position-fixed').css('padding-top'))) + 'px');
        const contentHeight = mainContent.height();
        const thumbnailHeight = $('.book-thumbnail, .people-thumbnail').height();
        if (contentHeight < thumbnailHeight)
            mainContent.css('min-height', thumbnailHeight);
        this.resizeCover();
    }
    static resizeCover() {
        if (!this.enableCoverResize)
            return;
        const scroll = window.scrollY;
        this.covers.each((cover, index) => {
            const originalWidth = cover.parent().width();
            const coverMinWidth = this.coversMaxHeight[index] * (cover.width() / cover.height());
            let width = originalWidth - scroll;
            if (width < coverMinWidth)
                width = coverMinWidth;
            cover.css('width', width);
        });
    }
}
CoverResizer.enableCoverResize = false;
CoverResizer.coversMaxHeight = [];
CoverResizer.covers = $('.book-informations .book-thumbnail, .people-informations .people-thumbnail');
